import { IWorkflow, StatePropertyValue } from 'stores/Workflows/Types'
import { Property } from 'api/clients/PropertyClient'
import { WorkflowTemplate } from 'components/FolderTemplatesDialog/Types'

interface Props {
  template: WorkflowTemplate
  workflowData: IWorkflow<Property<StatePropertyValue>>
}

export const workflowFromTemplate = ({ template, workflowData }: Props) => {
  return {
    configuration: template.statuses.configuration,
    property: {
      ...workflowData.property,
      property_values: template.statuses.property_values.map((value) => ({
        ...value,
        property_id: workflowData.property.id,
      })),
    },
    channels: workflowData.channels,
    users: workflowData.users,
    folder: workflowData.folder,
  }
}
